import styled from "styled-components";

export const ArrowButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px 25px;
  color: #fff;
  background: #e20074;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  line-height: 1.4;
  width: 280px;
  height: 100px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: filter 0.2s ease-in-out;
  flex-shrink: 0;
  overflow: hidden;
  word-wrap: break-word;
  
  clip-path: polygon(
    22px 50%,                 
    0% 0%,                    
    calc(100% - 22px) 0%,     
    100% 50%,                 
    calc(100% - 22px) 100%,   
    0% 100%,                  
    22px 50%                  
  );

  background-image: linear-gradient(180deg, rgba(255,255,255,0.1), rgba(0,0,0,0.05));

  &:hover { filter: brightness(1.05); }
  &:active { filter: brightness(0.95); }
  &:focus {
    outline: 2px solid #ff90c8;
    outline-offset: 2px;
  }

  div {
    max-width: 100%;
    overflow-wrap: break-word;
    word-break: break-word;
    hyphens: auto;
  }

  /* Tablet and smaller screens */
  @media (max-width: 1024px) {
    width: 240px;
    height: 110px;
    font-size: 11px;
    padding: 12px 18px;
    line-height: 1.3;
    
    clip-path: polygon(
      18px 50%,
      0% 0%,
      calc(100% - 18px) 0%,
      100% 50%,
      calc(100% - 18px) 100%,
      0% 100%,
      18px 50%
    );
  }

  /* Mobile screens */
  @media (max-width: 768px) {
    width: 160px;
    height: 90px;
    font-size: 8px;
    padding: 6px 8px;
    line-height: 1.2;
    
    clip-path: polygon(
      12px 50%,
      0% 0%,
      calc(100% - 12px) 0%,
      100% 50%,
      calc(100% - 12px) 100%,
      0% 100%,
      12px 50%
    );
  }

  /* When 4 buttons are shown - make them smaller on tablets */
  .four-buttons & {
    @media (max-width: 768px) {
      width: 140px;
      height: 85px;
      font-size: 7.5px;
      padding: 5px 7px;
      
      clip-path: polygon(
        10px 50%,
        0% 0%,
        calc(100% - 10px) 0%,
        100% 50%,
        calc(100% - 10px) 100%,
        0% 100%,
        10px 50%
      );
    }
  }

  /* Small mobile screens */
  @media (max-width: 480px) {
    width: 115px;
    height: 80px;
    font-size: 7px;
    padding: 4px 6px;
    line-height: 1.15;
    font-weight: 500;
    
    clip-path: polygon(
      8px 50%,
      0% 0%,
      calc(100% - 8px) 0%,
      100% 50%,
      calc(100% - 8px) 100%,
      0% 100%,
      8px 50%
    );
  }

  /* When 4 buttons are shown - make them smaller on mobile */
  .four-buttons & {
    @media (max-width: 480px) {
      width: 85px;
      height: 75px;
      font-size: 6.5px;
      padding: 3px 5px;
      line-height: 1.1;
      
      clip-path: polygon(
        7px 50%,
        0% 0%,
        calc(100% - 7px) 0%,
        100% 50%,
        calc(100% - 7px) 100%,
        0% 100%,
        7px 50%
      );
    }
  }

  /* Extra small mobile screens */
  @media (max-width: 390px) {
    width: 90px;
    height: 75px;
    font-size: 6.5px;
    padding: 3px 5px;
    line-height: 1.1;
    font-weight: 500;
    
    clip-path: polygon(
      7px 50%,
      0% 0%,
      calc(100% - 7px) 0%,
      100% 50%,
      calc(100% - 7px) 100%,
      0% 100%,
      7px 50%
    );
  }

  /* When 4 buttons are shown - make them smaller on small screens */
  .four-buttons & {
    @media (max-width: 390px) {
      width: 75px;
      height: 72px;
      font-size: 6px;
      padding: 2px 4px;
      line-height: 1.05;
      
      clip-path: polygon(
        6px 50%,
        0% 0%,
        calc(100% - 6px) 0%,
        100% 50%,
        calc(100% - 6px) 100%,
        0% 100%,
        6px 50%
      );
    }
  }

  /* Very small mobile screens (iPhone SE, etc.) */
  @media (max-width: 360px) {
    width: 80px;
    height: 72px;
    font-size: 6px;
    padding: 2px 4px;
    line-height: 1.05;
    font-weight: 500;
    
    clip-path: polygon(
      6px 50%,
      0% 0%,
      calc(100% - 6px) 0%,
      100% 50%,
      calc(100% - 6px) 100%,
      0% 100%,
      6px 50%
    );
  }

  /* When 4 buttons are shown - make them even smaller on very small screens */
  .four-buttons & {
    @media (max-width: 360px) {
      width: 68px;
      height: 70px;
      font-size: 5.5px;
      padding: 2px 3px;
      
      clip-path: polygon(
        5px 50%,
        0% 0%,
        calc(100% - 5px) 0%,
        100% 50%,
        calc(100% - 5px) 100%,
        0% 100%,
        5px 50%
      );
    }
  }
`;